import {Button, Container, Paper, Typography} from "@mui/material";

import {useState} from "react";
import {NavLink} from "react-router-dom";
import PhoneNumberCommonComponent from "../components/PhoneNumberCommonComponent";
import EnterCodeAuthenticatorComponent from "../components/EnterCodeAuthenticatorComponent";
import Countdown from "react-countdown";
import {useTranslation} from "i18nano";
import {ApiService} from "../api/ApiService";
import {useAuthStore} from "../stores/authStore";
import {useUserStore} from "../stores/userStore";
import {useNotification} from "../stores/notificationStore";

const PhoneTwoFactorAuthentication = () => {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const notification = useNotification();
    const t = useTranslation();

    const [loading, setLoading] = useState<boolean>(false);
    const [phone, setPhone] = useState<string>("");
    const [step, setStep] = useState<number>(0);
    const [errors, setErrors] = useState<string[]>([]);

    const sendCode = async (code: string) => {
        setLoading(true)
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.Login(authStore.login, authStore.password, code, 1);
        if (response.success) {
            userStore.login(response.data);
        } else {
            notification.open(response.errors[0], "error");
        }
        setLoading(false);
    }

    const sendSms = async (phoneNumber: string) => {
        setLoading(true)
        setPhone(phoneNumber);

        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.GetSms(authStore.login, authStore.password, phoneNumber);
        if (response.success) {
            setStep(1)
            localStorage.setItem("lastSendSms", new Date().getTime().toString())
        } else {
            setErrors([response.errors[0]])
            notification.open(response.errors[0], "error");
        }
        setLoading(false)
    }

    return (
        <Paper elevation={1} style={{padding: "40px 20px", margin: "auto", marginTop: "40px", maxWidth: "450px"}}>
            <Container>
                {step === 0 ?
                    <>
                        <PhoneNumberCommonComponent errors={errors} onClick={sendSms} loading={loading}/>
                        {authStore.response && authStore.response.data && authStore.response.data.availableTwoFactorProviders.includes(0) ?
                            <NavLink to={"/two-factor-authentication"}
                                     style={{display: "block", width: "100%", textAlign: "center", marginTop: "10px"}}>
                                {t("Use authenticator instead")}
                            </NavLink>
                            : null
                        }
                    </>
                    :
                    <>
                        <EnterCodeAuthenticatorComponent
                            onClick={sendCode} loading={loading}
                            title={t("Enter Code")}
                            description={<span>{t("We have sent a verification code to your phone number")}</span>}
                        />
                        <div style={{display: 'flex', justifyContent: "center"}}>
                            <Countdown
                                date={Date.now() + 60 * 1000}
                                renderer={({seconds, completed}) => {
                                    if (completed) {
                                        return <Button style={{marginTop: 10}} variant="text" size={"small"}
                                                       onClick={() => sendSms(phone)}>{t("Send code again")}</Button>
                                    } else {
                                        return <Typography style={{marginTop: 10}} variant="body2" display="block"
                                                           gutterBottom>
                                            {t("You can send code again after seconds", {seconds: `${seconds === 0 ? "" : seconds}`})}

                                        </Typography>
                                    }
                                }}
                            />
                        </div>
                    </>
                }
            </Container>
        </Paper>
    )
}

export default PhoneTwoFactorAuthentication;